import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './GenerateReportPage.css';
import Notification from '../../components/Notification';
import Header from '../../components/Header';
import InspectionDateRangeReport from '../../components/InspectionDateRangeReport';
import PlateCrossReferenceReport from '../../components/PlateCrossReferenceReport';
import logger from '../../utils/logger';

const GenerateReportPage = () => {
    const navigate = useNavigate();
    const [notification, setNotification] = useState({ visible: false, message: '', type: 'info' });

    const showNotification = (message, type = 'info') => {
        setNotification({ visible: true, message, type });
        setTimeout(() => {
            setNotification({ visible: false, message: '', type: 'info' });
        }, 5000);
    };

    const handleGoBack = () => {
        logger.info('Volviendo al home', null, 'GenerateReportPage');
        navigate('/');
    };

    return (
        <div className="generate-report-page">
            <Header />
            <main className="generate-report-content">
                <div className="generate-report-layout">
                    <div className="generate-report-header">
                        <h1 className="page-report-title">Reportes</h1>
                        <button
                            type="button"
                            className="btn-generate-report btn-generate-report-secondary"
                            onClick={handleGoBack}
                        >
                            Volver
                        </button>
                    </div>

                    <InspectionDateRangeReport onNotify={showNotification} />
                    <PlateCrossReferenceReport onNotify={showNotification} />
                </div>
            </main>

            <Notification
                visible={notification.visible}
                message={notification.message}
                type={notification.type}
                onClose={() => setNotification({ visible: false, message: '', type: 'info' })}
            />
        </div>
    );
};

export default GenerateReportPage;
